import {FiArrowRight} from 'react-icons/fi';
import clsx from 'clsx';

import type {LinkProps} from '@/modules/foundation/components/link';
import {Link} from '@/modules/foundation/components/link';
import {cn} from '@/modules/foundation/shared/tailwind';

export type NavLinkType = LinkProps & {
	featured?: boolean;
};

type NavLinkProps = LinkProps & {
	featured?: boolean;
};

export const NavLink = ({featured, children, className, ...rest}: NavLinkProps) => {
	if (featured) {
		return (
			<Link
				className={cn(
					[
						'group',
						'font-semibold',
						'no-underline',
						'items-center',
						'gap-2',
						'inline-flex',
						'hover:text-link',
						'transition-colors',
						'text-sm',
						'min-[1070px]:text-base',
					],
					className,
				)}
				{...rest}
			>
				{children}
				<FiArrowRight
					aria-hidden
					className={clsx('text-[#83909B]', 'group-hover:ml-1', 'transition-all')}
				/>
			</Link>
		);
	}

	return (
		<Link
			className={cn(
				[
					'inline-block',
					'no-underline',
					'hover:text-link',
					'transition-colors',
					'text-sm',
					'min-[1070px]:text-base',
				],
				className,
			)}
			{...rest}
		>
			{children}
		</Link>
	);
};
